import { getUserId } from '../utils/userId';

const API_BASE_URL = '/api';

/**
 * API 호출에 필요한 헤더를 생성합니다.
 */
const getHeaders = (): HeadersInit => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const userId = getUserId();
  if (userId) {
    headers['X-USER-ID'] = userId;
  }

  return headers;
};

export interface ReadStatusResponse {
  verseList: number[];
}

export class ReadApiService {
  /**
   * 특정 장의 읽음 상태를 조회합니다.
   */
  static async getReadStatus(
    bookNo: number,
    chapter: number
  ): Promise<ReadStatusResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/read/${bookNo}/${chapter}`, {
        method: 'GET',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('읽음 상태 조회 중 오류가 발생했습니다:', error);
      throw error;
    }
  }

  /**
   * 특정 절을 읽음 처리합니다.
   */
  static async markAsRead(
    bookNo: number,
    chapter: number,
    verse: number
  ): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/read/${bookNo}/${chapter}`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ verse })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('읽음 처리 중 오류가 발생했습니다:', error);
      throw error;
    }
  }

  /**
   * 특정 장의 읽음 상태를 삭제합니다.
   */
  static async deleteChapterReadStatus(
    bookNo: number,
    chapter: number
  ): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/read/${bookNo}/${chapter}`, {
        method: 'DELETE',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('읽음 상태 삭제 중 오류가 발생했습니다:', error);
      throw error;
    }
  }

  /**
   * 전체 읽음 상태를 삭제합니다.
   */
  static async deleteAllReadStatus(): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/read`, {
        method: 'DELETE',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('전체 읽음 상태 삭제 중 오류가 발생했습니다:', error);
      throw error;
    }
  }
}

